import {TestList} from "./TestList";
import {TestEdit} from "./TestEdit";
import {TestCreate} from "./TestCreate";

export default {
    list: TestList,
    create: TestCreate,
    edit: TestEdit
};
